import * as React from "react";
import { API_URL } from "General/APIEndpoints";
import { projectsDataStore } from "Stores/ProjectsStore";
import { observer } from "mobx-react";
import { UploadFile } from "antd/lib/upload/interface";
import { emailSubmitStore } from "../Stores/EmailSubmitStore";
import { BaseUpload } from "Components/General/BaseUpload";
import { FileUploadChunked } from "Pages/Project/Documents/FileUpload/FileUploadChunked";

export interface EmailUploadFile extends UploadFile {
  id?: string; // using this id for deleting file on the back-end temp
  // expiration: number;
}

interface EmailExternalFileUploadProps {
  children: React.ReactNode;
}

export const EmailExternalFileUpload = observer((props: EmailExternalFileUploadProps) => {
  const uploadURL = API_URL.FILE_UPLOAD_V3.uploadTemporaryFile(projectsDataStore.projectId);

  const uploadProps = {
    onChange: ({ file }) => emailSubmitStore.addExternalFile(file),
    action: uploadURL,
    showUploadList: false,
    multiple: true,
    beforeUpload: (file) => FileUploadChunked.fileIsNotTooBig(file),
  };

  return <BaseUpload {...uploadProps} children={props.children} />;
});
